import {
    adapts,
    AmazonS3StoreReadSettingsAdapter
} from 'app/model/adapters/activities/copysource/store-read-settings/s3-store-read-settings.adapter';
import { AdapterRegistry, Metamodel } from 'shell-models-lib';
import { SapDatasphereForAmazonS3ReadSettings } from 'app/model/pipeline/copysource/store-read-settings/sap-datasphere-for-amazon-s3-read-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForAmazonS3ReadSettings),
    asynchronous: true,
    adapts
})
export class SapDatasphereForAmazonS3ReadSettingsAdapter extends AmazonS3StoreReadSettingsAdapter {}
